import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import classnames from '../../../_virtual/index.js';
import { useAccount, State } from '@grandvisionhq/auth';
import { Card, Price, Loader, Button, MediaQuery } from '@grandvisionhq/common';
import { useLink } from '@grandvisionhq/frk-routing';
import { Icon } from '@grandvisionhq/icons';
import { StockIndicator } from '@grandvisionhq/inventory';
import { BackInStockModal, BackInStockButton } from '@grandvisionhq/lib-visuals';
import { useIntl, useFeatureToggles } from '@grandvisionhq/state';
import { useAddBackInStockSubscription, pushBackInStockSubscriptionEvent, pushBackInStockButtonClickEvent } from '@grandvisionhq/svc-back-in-stock';
import { placeholderImage } from '@grandvisionhq/utils';
import { pushWishlistEvent } from '../../../data-layer/wishlist.js';
import { getWishlistItemImage } from '../../../utils/get-wishlist-item-image.js';
import { WishlistItemDescription } from './WishlistItemDescription.js';

const WishlistItem = ({ isUpdateLoading , item , onUpdateWishList  })=>{
    const { getLabel  } = useIntl();
    const { useIsPhone  } = MediaQuery;
    const isPhone = useIsPhone();
    const authState = useAccount();
    const isUserLoggedIn = authState === State.AuthState.LoggedIn;
    const { isBackInStockEnabled  } = useFeatureToggles();
    const { addBackInStockSubscription , isSubscribed  } = useAddBackInStockSubscription();
    const [isBackInStockModalOpen, setIsBackInStockModalOpen] = React.useState(false);
    const { name , sku , brand , originalPrice , discountedPrice , discountValue , currencyCode , slug , productType , showBackInStockNotification , isAllowBackOrder , stockCount , channelAvailability , isExcludedFromCheckout ,  } = item;
    const handleNotifyClick = ()=>{
        pushBackInStockButtonClickEvent(productType, name, brand);
        setIsBackInStockModalOpen(true);
    };
    const handleModalClose = ()=>setIsBackInStockModalOpen(false)
    ;
    const handleBackInStockFormSubmit = function() {
        var _ref = swcHelpers.asyncToGenerator(function*(email) {
            const success = yield addBackInStockSubscription({
                email,
                sku
            });
            const backInStockSubscriptionEvent = {
                sessionStatus: isUserLoggedIn ? 'logged_in' : 'logged_out',
                itemType: productType,
                itemName: name,
                itemBrand: brand,
                message_type: success ? 'success' : 'error'
            };
            pushBackInStockSubscriptionEvent(backInStockSubscriptionEvent);
        });
        return function handleBackInStockFormSubmit(email) {
            return _ref.apply(this, arguments);
        };
    }();
    const labels = {
        removeItem: getLabel('account.wishlist.item.remove'),
        discount: getLabel('cart.item.discount'),
        notify: getLabel('account.wishlist.item.notify'),
        notifyAriaLabel: getLabel('account.wishlist.item.notify.ariaLabel'),
        notificationSet: getLabel('account.wishlist.item.notificationSet')
    };
    const productPageHref = useLink({
        route: 'products.detail',
        params: {
            slug,
            sku,
            key: productType
        }
    }, {
        withParams: false
    });
    const onWishlistItemClick = ()=>{
        pushWishlistEvent({
            siteFeature: 'my_account',
            interactionType: 'wishlist_product_click',
            userLogged: isUserLoggedIn ? 'logged_in' : 'logged_out',
            item: {
                sku
            }
        });
    };
    var ref;
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(BackInStockModal, {
        isOpen: isBackInStockModalOpen,
        onModalClose: handleModalClose,
        onSubmit: handleBackInStockFormSubmit
    }), /*#__PURE__*/ React.createElement(Card, {
        layout: isPhone ? 'vertical' : 'horizontal',
        className: "wishlist-item"
    }, /*#__PURE__*/ React.createElement(Card.Image, {
        backgroundColor: "var(--color--shade-lightest)",
        alt: name,
        src: (ref = getWishlistItemImage(item)) !== null && ref !== void 0 ? ref : placeholderImage.url,
        imageHref: productPageHref === null || productPageHref === void 0 ? void 0 : productPageHref.href,
        className: "wishlist-item__image",
        onClick: onWishlistItemClick
    }), /*#__PURE__*/ React.createElement(Card.Content, null, /*#__PURE__*/ React.createElement("div", {
        className: "wishlist-item__product-content"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "wishlist-item__main-column"
    }, /*#__PURE__*/ React.createElement(Card.Section, {
        className: "wishlist-item__top-row"
    }, /*#__PURE__*/ React.createElement(Card.Heading, {
        component: "h2",
        className: "wishlist-item__title",
        variant: "subheading1"
    }, name)), /*#__PURE__*/ React.createElement(Card.Section, {
        className: "wishlist-item__attributes"
    }, /*#__PURE__*/ React.createElement(WishlistItemDescription, {
        item: item
    }))), /*#__PURE__*/ React.createElement("div", {
        className: "wishlist-item__side-column"
    }, /*#__PURE__*/ React.createElement(Card.Section, {
        className: "wishlist-item__prices-container"
    }, discountedPrice !== 0 && discountedPrice ? /*#__PURE__*/ React.createElement(Price, {
        value: discountedPrice,
        currency: currencyCode,
        centAmount: false,
        className: classnames('wishlist-item__price', 'wishlist-item__price--large')
    }) : null, originalPrice !== 0 && originalPrice ? /*#__PURE__*/ React.createElement(Price, {
        value: originalPrice,
        currency: currencyCode,
        type: discountedPrice && discountedPrice > 0 ? 'strikethrough' : 'default',
        centAmount: false,
        className: classnames('wishlist-item__price', {
            'wishlist-item__price--large': !discountedPrice
        })
    }) : null, discountValue !== 0 && discountValue ? /*#__PURE__*/ React.createElement(Card.Text, {
        className: "wishlist-item__discount-information"
    }, /*#__PURE__*/ React.createElement("span", {
        className: "wishlist-item__discount-label"
    }, labels.discount, "\xa0"), /*#__PURE__*/ React.createElement("span", null, discountValue, "%")) : null))), /*#__PURE__*/ React.createElement("div", {
        className: "wishlist-item__cta"
    }, !isExcludedFromCheckout ? /*#__PURE__*/ React.createElement(Card.Section, null, /*#__PURE__*/ React.createElement(StockIndicator, {
        allowBackOrder: !!isAllowBackOrder,
        stockCount: stockCount !== null && stockCount !== void 0 ? stockCount : undefined,
        channelAvailability: channelAvailability
    })) : null, /*#__PURE__*/ React.createElement(Card.Section, {
        flex: true,
        className: "wishlist-item__actions"
    }, isUpdateLoading ? /*#__PURE__*/ React.createElement(Loader, {
        className: "wishlist-item__loading"
    }) : /*#__PURE__*/ React.createElement(React.Fragment, null, showBackInStockNotification && isBackInStockEnabled ? isSubscribed ? /*#__PURE__*/ React.createElement("div", {
        className: "wishlist-item__notification"
    }, /*#__PURE__*/ React.createElement(Icon, {
        name: "checkmark"
    }), /*#__PURE__*/ React.createElement(Card.Text, {
        variant: "body-head"
    }, labels.notificationSet)) : /*#__PURE__*/ React.createElement(BackInStockButton, {
        onNotifyClick: handleNotifyClick
    }) : null, /*#__PURE__*/ React.createElement(Button, {
        caption: labels.removeItem,
        "aria-label": labels.removeItem,
        icon: "trash",
        variant: "ghost",
        size: "custom",
        className: "wishlist-item__button",
        onClick: onUpdateWishList
    })))))));
};

export { WishlistItem as default };
//# sourceMappingURL=WishlistItem.js.map
